export default __webpack_public_path__ + "static/media/TWITTER_v.e4a72080.svg";